import React from 'react';

interface PaginacaoControlsProps {
  paginaAtual: number;
  totalPaginas: number;
  totalItens: number;
  itensPorPagina: number;
  onPaginaChange: (pagina: number) => void;
  variant?: 'completa' | 'simples';
}

export const PaginacaoControls: React.FC<PaginacaoControlsProps> = ({
  paginaAtual,
  totalPaginas,
  totalItens,
  itensPorPagina,
  onPaginaChange,
  variant = 'completa',
}) => {
  if (totalPaginas <= 1) return null;

  const indiceInicio = (paginaAtual - 1) * itensPorPagina;
  const indiceFim = Math.min(indiceInicio + itensPorPagina, totalItens);

  const paginaAnterior = () => {
    if (paginaAtual > 1) {
      onPaginaChange(paginaAtual - 1);
    }
  };

  const proximaPagina = () => {
    if (paginaAtual < totalPaginas) {
      onPaginaChange(paginaAtual + 1);
    }
  };

  if (variant === 'simples') {
    return (
      <div className="flex items-center justify-center bg-white rounded-lg border px-4 py-3">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => onPaginaChange(1)}
            disabled={paginaAtual === 1}
            className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Primeira
          </button>
          
          <button
            onClick={paginaAnterior}
            disabled={paginaAtual === 1}
            className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            ← Anterior
          </button>
          
          <span className="text-sm text-gray-600 px-4">
            {paginaAtual} / {totalPaginas}
          </span>
          
          <button
            onClick={proximaPagina}
            disabled={paginaAtual === totalPaginas}
            className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Próxima →
          </button>
          
          <button
            onClick={() => onPaginaChange(totalPaginas)}
            disabled={paginaAtual === totalPaginas}
            className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Última
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between bg-white rounded-lg border px-4 py-3">
      <div className="flex items-center space-x-2 text-sm text-gray-600">
        <span>Página {paginaAtual} de {totalPaginas}</span>
        <span>•</span>
        <span>Exibindo {indiceFim - indiceInicio} de {totalItens.toLocaleString()} itens</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <button
          onClick={paginaAnterior}
          disabled={paginaAtual === 1}
          className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Anterior
        </button>
        
        {/* Páginas numeradas */}
        <div className="flex items-center space-x-1">
          {Array.from({ length: Math.min(5, totalPaginas) }, (_, i) => {
            let pageNum:any;
            if (totalPaginas <= 5) {
              pageNum = i + 1;
            } else if (paginaAtual <= 3) {
              pageNum = i + 1;
            } else if (paginaAtual >= totalPaginas - 2) {
              pageNum = totalPaginas - 4 + i;
            } else {
              pageNum = paginaAtual - 2 + i;
            }
            
            return (
              <button
                key={pageNum}
                onClick={() => onPaginaChange(pageNum)}
                className={`w-8 h-8 text-sm rounded transition-colors ${
                  pageNum === paginaAtual
                    ? 'bg-blue-600 text-white'
                    : 'border border-gray-300 hover:bg-gray-50'
                }`}
              >
                {pageNum}
              </button>
            );
          })}
        </div>
        
        <button
          onClick={proximaPagina}
          disabled={paginaAtual === totalPaginas}
          className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Próxima
        </button>
      </div>
    </div>
  );
};